import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const statHandleChartLocaleModule: LocaleModule = {
  name: "statHandleChart",
  messages: { en: en, it: it },
};
